import {
  Injectable
} from '@angular/core';
import {
  Observable
,
  BehaviorSubject
,
  Subscription
} from 'rxjs';
import {
  ApiService
} from '../services/api';
import {
  HttpParams
} from '@angular/common/http';
import {
  GridDataResult
} from '@progress/kendo-angular-grid';
import {UserContext} from '../services/user-context';

@Injectable()
export class DistributorLocationsService extends BehaviorSubject<GridDataResult> {
  public subscription: Subscription;

  constructor(private api: ApiService, private userContext: UserContext,) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }

  public getLocations(page: number, limit: number, cb: any, account?: string, search?: string) {
    const params = new HttpParams()
    .set('page', page.toLocaleString())
    .set('limit', limit.toString())
    .set('search', search);

    if ( account ) {
      params.set('account', account);
    }

  this.subscription = this.api.get<GridDataResult>(`/distributor/${encodeURI(this.userContext.user.reference || '0')}/locations`, params)
      .subscribe(result => {
        super.next(result);
      });
  }
}
